import moment from 'moment'

/**
 * Date format 'YYYY-MM-DD'
 * @type {string}
 */
export const FORMAT_DATE = moment.HTML5_FMT.DATE
